import { TAppTypesDisplaySubsitutes } from 'types/apps'

type TReturnDropdownValue = {
  name: TAppTypesDisplaySubsitutes
  option: string
  isActiveCheckAccordion: boolean
}

export const setAddRoleValues = (
  value: TReturnDropdownValue,
  permissions: TReturnDropdownValue[],
  setFieldValue: (field: string, value: TReturnDropdownValue[], shouldValidate?: boolean) => void
) => {
  // array of permissions names
  const initialPermissionsNames = permissions?.map((permission) => permission?.name)

  // remove old or unselected permission
  const permissionsWithoutCurrentPermission = permissions?.filter(
    (permission) => permission.name !== value.name
  )

  // when isActiveCheckAccordion === false we have to remove this permission
  if (!value.isActiveCheckAccordion) {
    return setFieldValue('permissions', permissionsWithoutCurrentPermission)
  }

  // check if last selected permission exist in initial values
  if (
    initialPermissionsNames?.includes(value.name as TAppTypesDisplaySubsitutes) &&
    value.isActiveCheckAccordion
  ) {
    // fill existed permissions with new selected permission
    const newPermissions = [...permissionsWithoutCurrentPermission, value]

    setFieldValue('permissions', newPermissions)
  } else {
    setFieldValue('permissions', [...permissions, value])
  }
}
